// Shared electrical-unit scaling helpers. Kept in lib/ (not a component) so
// consumers — ServiceTile, TotalLoadWidget — can import them without dragging
// in the uPlot chart stack.

/**
 * Auto-scale a watts value into a (value, unit, digits) tuple. Below 10 kW
 * display in W with no decimals (e.g. "1234 W"); at and above 10 kW display
 * in kW with 2 decimals (e.g. "12.34 kW"). 9999 W -> still W; 10000 W -> kW.
 */
export function scalePower(
  w: number,
): { value: number; unit: "W" | "kW"; digits: number } {
  return Math.abs(w) >= 10000
    ? { value: w / 1000, unit: "kW", digits: 2 }
    : { value: w, unit: "W", digits: 0 };
}

/** Auto-scale an apparent-power (VA) value, same thresholds as scalePower. */
export function scaleApparent(
  va: number,
): { value: number; unit: "VA" | "kVA"; digits: number } {
  return Math.abs(va) >= 10000
    ? { value: va / 1000, unit: "kVA", digits: 2 }
    : { value: va, unit: "VA", digits: 0 };
}
